import toastrError from 'src/helpers/toastr/toastrError';
import toastrSuccess from 'src/helpers/toastr/toastrSuccess';
import { wtsApi } from 'src/api';
export var CommentsActions;
(function (CommentsActions) {
    CommentsActions["LOADING_COMMENTS"] = "LOADING_COMMENTS";
    CommentsActions["NOT_LOADING_COMMENTS"] = "NOT_LOADING_COMMENTS";
    CommentsActions["SAVE_COMMENTS"] = "SAVE_COMMENTS";
    CommentsActions["ADD_COMMENT"] = "ADD_COMMENT";
    CommentsActions["UPDATE_COMMENT"] = "UPDATE_COMMENT";
    CommentsActions["DELETE_COMMENT"] = "DELETE_COMMENT";
    CommentsActions["ERROR"] = "ERROR";
})(CommentsActions || (CommentsActions = {}));
export function loadingComments() {
    return { type: CommentsActions.LOADING_COMMENTS };
}
export function notLoadingComments() {
    return { type: CommentsActions.NOT_LOADING_COMMENTS };
}
export function saveCommentsLocally(comments) {
    return { type: CommentsActions.SAVE_COMMENTS, payload: comments };
}
export function addCommentLocally(comment) {
    return { type: CommentsActions.ADD_COMMENT, payload: comment };
}
export function updateCommentLocally(comment) {
    return { type: CommentsActions.UPDATE_COMMENT, payload: comment };
}
export function deleteCommentLocally(commentId) {
    return { type: CommentsActions.DELETE_COMMENT, payload: commentId };
}
export function commentError() {
    return { type: CommentsActions.ERROR };
}
export function loadComments() {
    return (dispatch) => {
        dispatch(loadingComments());
        return wtsApi.comments.commentsList()
            .then(({ data }) => {
            const result = data.Data;
            dispatch(saveCommentsLocally(result));
            return result;
        })
            .catch((error) => {
            console.error(error);
            dispatch(notLoadingComments());
            toastrError(error);
            return Promise.reject();
        });
    };
}
export function addComment(comment) {
    return (dispatch) => {
        dispatch(loadingComments());
        return wtsApi.comments.commentsCreate(comment)
            .then(({ data }) => {
            const result = data.Data;
            dispatch(addCommentLocally(result));
            toastrSuccess();
            return result;
        })
            .catch((error) => {
            console.error(error);
            toastrError(error);
            dispatch(commentError());
            return Promise.reject();
        });
    };
}
export function updateComment({ Id, Comment }) {
    return (dispatch) => {
        dispatch(loadingComments());
        return wtsApi.comments.commentsUpdate(Id, { Comment })
            .then(({ data }) => {
            const result = data.Data;
            dispatch(updateCommentLocally(result));
            toastrSuccess();
            return result;
        })
            .catch((error) => {
            console.error(error);
            toastrError(error);
            dispatch(commentError());
            return Promise.reject();
        });
    };
}
export function deleteComment(commentId) {
    return (dispatch) => {
        dispatch(loadingComments());
        return wtsApi.comments.commentsDelete(commentId)
            .then(({ data }) => {
            dispatch(deleteCommentLocally(commentId));
            toastrSuccess();
            return data.Data;
        })
            .catch((error) => {
            console.error(error);
            toastrError(error);
            dispatch(commentError());
            return Promise.reject();
        });
    };
}
